<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
        <b-col cols="12">
          <status-select />
        </b-col>
      </b-row>
    </b-card>
    <image-card />
    <b-button
      variant="primary"
      :disabled="dataItem.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import { required } from '@validations'

import TitleText from '@/views/Welcome/elements/TitleText.vue'
import ContentText from '@/views/Welcome/elements/ContentText.vue'
import StatusSelect from '@/views/Welcome/elements/StatusSelect.vue'
import ImageCard from '@/views/Welcome/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    ContentText,
    StatusSelect,
    ImageCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['welcome/dataItem']
    },
  },
  mounted() {
    this.dataItem.submitStatus = false
  },
}
</script>
